<template>
  <div class="test-records">
    <router-view v-if="$route.name === 'VersionList'"></router-view>
    <enfold v-else>
      <enfold-cd>
        <template slot="center">
          <div class="layout-container">
            <!-- 左侧：设备列表 -->
            <div class="left-panel">
              <!-- 搜索栏 -->
              <div class="search-bar">
                <el-input v-model="search.key_word" placeholder="序列号" clearable size="small" style="width: 140px"
                  @keyup.enter.native="handleSearch"></el-input>
                <el-select v-model="search.model" placeholder="型号" clearable size="small" style="width: 120px">
                  <el-option label="KU1" value="KU1"></el-option>
                  <el-option label="KU2" value="KU2"></el-option>
                  <el-option label="KU4" value="KU4"></el-option>
                </el-select>
                <el-select v-model="search.overall_pass" placeholder="测试结果" clearable size="small" style="width: 120px">
                  <el-option label="通过" :value="1"></el-option>
                  <el-option label="未通过" :value="0"></el-option>
                </el-select>
                <el-date-picker v-model="search.dateRange" type="daterange" range-separator="-" start-placeholder="开始日期"
                  end-placeholder="结束日期" value-format="yyyy-MM-dd" size="small" style="width: 280px"></el-date-picker>
                <el-button type="primary" size="small" round icon="el-icon-search" @click="handleSearch">查询</el-button>
                <el-button size="small" round icon="el-icon-refresh" @click="handleReset">重置</el-button>
                <el-button type="success" size="small" round icon="el-icon-setting"
                  @click="goVersionList">测试版本配置</el-button>
              </div>

              <!-- 数据表格 -->
              <div class="table-wrapper">
                <el-table :data="recordList" style="width: 100%" height="100%" v-loading="loading" highlight-current-row
                  @row-click="handleRowClick">
                  <el-table-column prop="sn" label="序列号"></el-table-column>
                  <el-table-column prop="model" label="型号"></el-table-column>
                  <el-table-column prop="round_no" label="轮次">
                    <template slot-scope="scope">
                      <span>第{{ scope.row.round_no }}次</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="test_time" label="测试时间" width="180">
                    <template slot-scope="scope">
                      {{ scope.row.test_time }}
                    </template>
                  </el-table-column>
                  <el-table-column label="自动测试">
                    <template slot-scope="scope">
                      <span :class="scope.row.auto_pass === scope.row.auto_total ? 'pass' : 'fail'">
                        {{ scope.row.auto_pass }} / {{ scope.row.auto_total }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="手动测试">
                    <template slot-scope="scope">
                      <span :class="scope.row.manual_pass === scope.row.manual_total ? 'pass' : 'fail'">
                        {{ scope.row.manual_pass }} / {{ scope.row.manual_total }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="整体结果">
                    <template slot-scope="scope">
                      <el-tag :type="scope.row.overall_pass ? 'success' : 'danger'" size="small">{{
                        scope.row.overall_pass ? '通过' : '未通过' }}</el-tag>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="remark" label="备注" min-width="120"></el-table-column> -->
                </el-table>
              </div>

              <!-- 分页 -->
              <pagination :current="current" :limit="limit" @currentChange="currentChange"></pagination>
            </div>

            <!-- 右侧：测试详情 -->
            <div class="right-panel" v-loading="detailLoading">
              <template v-if="detailData.record">
                <div class="detail-header">
                  <span>序列号: <b>{{ detailData.record.sn }}</b></span>
                  <span>型号: <b>{{ detailData.record.model }}</b></span>
                  <span>轮次: <b>第{{ detailData.record.round_no }}次</b></span>
                  <span>时间: <b>{{ detailData.record.test_time }}</b></span>
                  <el-tag :type="detailData.record.overall_pass ? 'success' : 'danger'" size="small">{{
                    detailData.record.overall_pass ? '通过' : '未通过' }}</el-tag>
                </div>

                <div class="detail-section">
                  <div class="section-title">自动测试 ({{ detailData.record.auto_pass }}/{{ detailData.record.auto_total }})
                  </div>
                  <el-table :data="detailData.autoTests" size="small" border>
                    <el-table-column prop="item_name" label="测试项" width="150"></el-table-column>
                    <el-table-column prop="item_value" label="值" min-width="200"></el-table-column>
                    <el-table-column label="结果" width="80">
                      <template slot-scope="scope">
                        <el-tag :type="scope.row.result === 1 ? 'success' : scope.row.result === 0 ? 'danger' : ''"
                          size="mini">{{
                            scope.row.result === 1 ? '通过' : scope.row.result === 0 ? '未通过' : '未测试' }}</el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>

                <div class="detail-section">
                  <div class="section-title">手动测试 ({{ detailData.record.manual_pass }}/{{ detailData.record.manual_total
                  }})</div>
                  <el-table :data="detailData.manualTests" size="small" border>
                    <el-table-column prop="item_name" label="测试项" min-width="200"></el-table-column>
                    <el-table-column label="结果" width="80">
                      <template slot-scope="scope">
                        <el-tag :type="scope.row.result === 1 ? 'success' : 'danger'" size="mini">{{ scope.row.result
                          === 1 ? '通过' :
                          '未通过' }}</el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
              <div v-else class="detail-empty">
                <i class="el-icon-document"></i>
                <p>请选择左侧设备查看测试详情</p>
              </div>
            </div>
          </div>
        </template>
      </enfold-cd>
    </enfold>
  </div>
</template>

<script>
import enfold from "@/components/basics/Enfold";
import EnfoldCd from "@/components/basics/EnfoldCD";
import pagination from "@/components/basics/Pagination";
import { mPagination } from "@/components/basics/mixins";

export default {
  name: "TestTecords",
  mixins: [mPagination],
  components: {
    enfold,
    EnfoldCd,
    pagination,
  },
  data() {
    return {
      loading: true,
      recordList: [],
      search: {
        key_word: "",
        model: "",
        overall_pass: "",
        dateRange: [],
      },
      detailLoading: false,
      detailData: {
        record: null,
        autoTests: [],
        manualTests: [],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      let params = {
        key_word: this.search.key_word || undefined,
        model: this.search.model || undefined,
        overall_pass: this.search.overall_pass !== "" ? this.search.overall_pass : undefined,
        start_time: this.search.dateRange && this.search.dateRange[0] ? this.search.dateRange[0] : undefined,
        end_time: this.search.dateRange && this.search.dateRange[1] ? this.search.dateRange[1] : undefined,
        page: this.page,
        limit: this.limit,
      };
      this.$http.post("/admin/testRecords/list", params, (data) => {
        this.recordList = data.list || [];
        this.current = parseInt(data.count) || 0;
        this.loading = false;
      });
    },
    handleSearch() {
      this.page = 1;
      this.getList();
    },
    handleReset() {
      this.search.key_word = "";
      this.search.model = "";
      this.search.overall_pass = "";
      this.search.dateRange = [];
      this.page = 1;
      this.getList();
    },
    currentChange(val) {
      this.page = val;
      this.getList();
    },
    handleRowClick(row) {
      this.detailLoading = true;
      this.detailData = { record: null, autoTests: [], manualTests: [] };
      this.$http.post(
        "/admin/testRecords/detail",
        { id: row.id },
        (data) => {
          this.detailData = data;
          this.detailLoading = false;
        }
      );
    },
    goVersionList() {
      this.$router.push({ name: "VersionList" });
    },
  },
};
</script>

<style lang="scss" scoped>
.test-records {
  width: 100%;
  height: 100%;

  // 分页已移入左侧面板，enfold-cd 的 down 槽不再使用，让 center 占满高度
  /deep/ .content {
    .center {
      height: 100%;
    }

    .down {
      display: none;
    }
  }

  .layout-container {
    display: flex;
    width: 100%;
    height: 100%;
  }

  .left-panel {
    flex: 3;
    min-width: 0;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #ebeef5;
  }

  .search-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 50px;
    padding: 0 8px;
    flex-shrink: 0;
  }

  .table-wrapper {
    flex: 1;
    min-height: 0;
    padding: 0 8px;
    box-sizing: border-box;
  }

  .right-panel {
    flex: 2;
    min-width: 0;
    padding: 0px 16px 16px 16px;
    box-sizing: border-box;
    overflow: auto;

    .detail-header {
      position: sticky;
      top: 0;
      z-index: 2;
      background: #fff;
      display: flex;
      align-items: center;
      gap: 16px;
      flex-wrap: wrap;
      padding-top: 16px;
      padding-bottom: 16px;
      border-bottom: 1px solid #ebeef5;
      font-size: 14px;

      b {
        color: var(--theme-color-customized-1);
      }
    }

    .detail-section {
      margin-top: 16px;

      .section-title {
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 8px;
        color: #303030;
      }
    }

    .detail-empty {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #909399;

      i {
        font-size: 48px;
        margin-bottom: 12px;
      }

      p {
        font-size: 14px;
        margin: 0;
      }
    }
  }

  .pass {
    color: #67c23a;
    font-weight: bold;
  }

  .fail {
    color: #f56c6c;
    font-weight: bold;
  }

  /deep/ .cell {
    font-size: 14px;
  }

  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 16px;
      color: var(--theme-color-customized-1);
    }
  }
}
</style>
